import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    api
      .post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data.user);
        window.history.replaceState(null, "", "/");
        toast.success(`Selamat datang, ${r.data.user.name}!`);
        navigate("/", { replace: true, state: { user: r.data.user } });
      })
      .catch(() => {
        toast.error("Gagal masuk. Silakan coba lagi.");
        navigate("/", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center paper-bg">
      <div className="text-center">
        <Loader2 className="w-10 h-10 mx-auto text-emerald-700 animate-spin" />
        <p className="mt-4 font-display font-bold text-lg">Menghubungkan warung...</p>
        <p className="text-sm text-stone-500">Sebentar ya, kami sedang menyiapkan pintu masuk.</p>
      </div>
    </div>
  );
}
